/**
 * #1804 — le supplément de poids impayé bloque la progression du colis.
 *
 * La garde AUTORITAIRE est serveur : `functions/src/domains/shipment/payment-gates.ts`
 * (`unpaidSurchargeBlockReason`, #1061), exécutée par `transitionShipmentStatus`.
 * Ce module ne peut pas être importé par Angular (ses accesseurs tirent
 * `firebase-admin`), donc les deux ensembles sont RECOPIÉS ici — et la copie est
 * verrouillée par `functions/src/tests/unit/weight-surcharge-gate-parity.test.ts`,
 * qui relit ce fichier et rougit à la moindre divergence. Ne pas éditer un côté
 * sans l'autre.
 *
 * Usage : l'écran de préparation annonce AVANT le clic que « Terminer
 * préparation » sera refusé. Le serveur reste seul à trancher.
 */

/** Statuts cibles que le serveur refuse tant qu'un supplément est impayé. */
export const SURCHARGE_GATED_TARGETS: readonly string[] = [
  'warehouse_sorted', 'destination_sorted', 'befret_transit',
];

/** Statuts de `weightDiscrepancy.status` qui valent « impayé ». */
export const UNPAID_SURCHARGE_STATUSES: readonly string[] = [
  'pending_payment', 'payment_link_sent',
  'reminder_1_sent', 'reminder_2_sent', 'reminder_3_sent',
  'return_to_sender',
];

/** Le statut visé par « Terminer préparation » (`completePreparation`, reception.service). */
export const COMPLETE_PREPARATION_TARGET_STATUS = 'warehouse_sorted';

/**
 * Motif à afficher avant le clic si le serveur refuserait la transition vers
 * `targetStatus` pour cause de supplément impayé ; `null` sinon.
 * Miroir de `unpaidSurchargeBlockReason` (serveur), sans autorité propre.
 */
export function unpaidSurchargeNotice(shipment: any, targetStatus: string): string | null {
  if (!SURCHARGE_GATED_TARGETS.includes(targetStatus)) return null;
  const wd = shipment?.weightDiscrepancy;
  if (!wd || wd.type !== 'surcharge') return null;
  if (!UNPAID_SURCHARGE_STATUSES.includes(wd.status)) return null;
  const amount = typeof wd.amount === 'number' ? `${wd.amount.toFixed(2)} ${wd.currency || 'EUR'}` : 'montant inconnu';
  return `Supplément de poids impayé (${amount}, statut « ${wd.status} ») — « Terminer préparation » `
    + 'sera refusé tant qu\'il n\'est pas réglé : attendre le paiement, résoudre l\'écart, ou forcer (manager, vaut renonciation).';
}
